import styled from 'styled-components';

export const Container = styled.div`
    .border {
        width: 100%;
        border: 1px dashed #C5CEE0;
        margin-top: -10px;
    }
`;